import Image from 'next/image'
import Section from 'components/common/Section'
import { SectionHeader } from 'components/marketing/SectionHeader'
import { Marketing } from 'designsystem/Text'
import { ComponentFeatures2X2Grid } from 'types/generated/contentful'
import { useThemeColor } from './ThemeContext'

export const Features2x2Grid = ({
  label,
  headline,
  subheadline,
  featuresCollection,
}: ComponentFeatures2X2Grid): JSX.Element => {
  const themeColor = useThemeColor()

  return (
    <Section bgColor='gray'>
      <SectionHeader
        label={label!}
        title={headline!}
        subline={subheadline!}
        highlight={themeColor}
      />

      <div className='max-w-screen-lg mx-auto'>
        <div className='grid gap-12 md:grid-cols-2 md:gap-14 lg:gap-x-30'>
          {featuresCollection?.items.map((feature, i) => (
            <div key={i} className='flex gap-5'>
              {feature!.icon && (
                <div className='flex items-center justify-center flex-shrink-0 w-12 h-12 rounded-8 bg-blue'>
                  <div className='w-7 h-7 relative'>
                    <Image
                      fill
                      src={feature!.icon.url!}
                      alt={feature!.icon.title!}
                    />
                  </div>
                </div>
              )}
              <div>
                <Marketing.H5>{feature!.title}</Marketing.H5>
                <p className='mt-3 whitespace-pre-line text-15 text-neutral-80 lg:text-18'>
                  {feature!.text}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Section>
  )
}
